var map = {
	"./commercial/0.jpg": 5364,
	"./commercial/1.jpg": 8982,
	"./commercial/2.jpg": 6685,
	"./commercial/3.jpg": 5255,
	"./commercial/4.jpg": 3937,
	"./food/0.jpg": 3613,
	"./food/1.jpg": 1378,
	"./food/2.jpg": 7701,
	"./food/3.jpg": 2126,
	"./food/4.jpg": 5419,
	"./landscape/0.jpg": 6039,
	"./landscape/1.jpg": 5057,
	"./landscape/2.jpg": 8964,
	"./landscape/3.jpg": 2307,
	"./landscape/4.jpg": 440,
	"./portraits/0.jpg": 796,
	"./portraits/1.jpg": 4263,
	"./portraits/2.jpg": 9761,
	"./portraits/3.jpg": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6025;